export default {
  computed: {
    isStandalone: function () {
      return window
        ? window.matchMedia('(display-mode: standalone)').matches ||
            (!!window.navigator && !!window.navigator.standalone)
        : false
    },
  },
}
